module.exports = __webpack_public_path__ + "img/brand-culture.10f639fe.png";